module.exports = __webpack_public_path__ + "img/corp.f2e28625.svg";